import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

import { addWithoutAdsToTemplates } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import styles from "./ipl.m.css";
import YoutubeVideoGallery from "./story/YoutubeReels";

const newTemplates = addWithoutAdsToTemplates("home");

function getAdsWrappedCollectionTemplate(designTemplate) {
  return newTemplates[designTemplate] || newTemplates.defaultTemplate;
}

const scrollToSection = (ref, offset = 0) => {
  if (!ref.current) return;
  const rect = ref.current.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  window.scrollTo({
    top: rect.top + scrollTop - offset,
    behavior: "smooth"
  });
};

export const IPL2026Page = ({ data, config, pageType }) => {
  const iframeWidgetsRef = useRef(null);
  const StoryCollectionWidgetsRef = useRef(null);

  useEffect(() => {
    GA.registerPageView(pageType, {});
    WebEngage.registerPageView();
    DeepBI.registerPageView({ collection: { pageType, data, config } });
    PGAD.loadScript();
  }, []);

  const handleFilter = slug => {
    if (slug === "Play Quiz") scrollToSection(iframeWidgetsRef, 50);
    else if (slug === "Worldcup Updates") scrollToSection(StoryCollectionWidgetsRef, 400);
  };

  return (
    <React.Fragment>
      <div
        className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]} ${
          styles["worldcup-page"]
        }`}
      >
        <div className="page-content infinity-page">
          <div className={styles["cricekt-header"]}>
            <ul>
              <li onClick={() => handleFilter("Play Quiz")}>Play Quiz</li>
              <li onClick={() => handleFilter("Worldcup Updates")}>IPL Updates</li>
            </ul>
          </div>

          <div className={styles["ipl-banner-section-2026"]}>
            <div className={`${styles["ipl-banner-section-2026-container"]} container`}>
              <div className={styles["player-sponcers"]}>
                <div>
                  <img src="https://media.vikatan.com/vikatan/2026-03-23/c0k51z8s/Player1.png" />
                </div>
                <div className={styles["banner-sec"]}>
                  <div className={styles["banner-logo-sec"]}>
                    <div className={styles["sathya-logo"]}>
                      <a
                        href="https://www.sathya.store/?utm_source=Eywa&utm_medium=QR_Code&utm_campaign=Sathya_Website_Vikatan_Ad"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <img
                          src="https://media.vikatan.com/vikatan/2024-03/61b8864b-846c-4573-82c5-726d86d0bca2/sathya_logo_slogen.png?format=webp&w=200&dpr=1.0"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className={styles["sporta-logo"]}>
                      <img
                        src="https://media.vikatan.com/vikatan/2023-10/aa815208-4e9c-4aef-8974-1d7d6646cc2e/sports_vikatan.png?format=webp&w=120&dpr=1.0"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className={styles["presents"]}>Presents</div>
                </div>
                <div>
                  <img src="https://media.vikatan.com/vikatan/2026-03-23/24u5m76e/Player2.png" />
                </div>
              </div>

              <div>
                <div
                  className={`${styles["banner-bottom-sec"]} ${styles["icc-banner-bottom-sec"]} ${
                    styles["icc-banner-bottom-sec-ipl"]
                  }`}
                >
                  <div>
                    <img
                      src="https://media.vikatan.com/vikatan/2026-03-23/fxr85kk5/Iplsixer2026.png?format=webp&w=600&dpr=1.0"
                      alt=""
                    />
                  </div>
                  <div>
                    <img src="https://media.vikatan.com/vikatan/2026-03-23/k3n8lgw3/participateinquiz.png?format=webp&w=600&dpr=1.0" />
                  </div>
                </div>

                <div
                  className={`${styles["banner-botton-overley"]} ${styles["t-banner-botton-overley"]} ${
                    styles["icc-banner-botton-overley"]
                  }`}
                >
                  <div className={`${styles["banner-bottom-prices"]} ${styles["icc-banner-bottom-prices"]}`}>
                    <div className={`${styles["other-prices"]} ${styles["icc-prices"]}`}>
                      <div>
                        <img
                          src="https://media.vikatan.com/vikatan/2026-03-23/jkhi97wl/1st.png?format=webp&w=360&dpr=1.0"
                          alt=""
                        />
                      </div>
                      <div>
                        <img
                          src="https://media.vikatan.com/vikatan/2026-03-23/7xxf22pj/2nd.png?format=webp&w=360&q=90"
                          alt=""
                        />
                      </div>
                      <div>
                        <img
                          src="https://media.vikatan.com/vikatan/2026-03-23/xqz0o849/3rd.png?format=webp&w=360&q=90"
                          alt=""
                        />
                      </div>
                      <div>
                        <img
                          src="https://media.vikatan.com/vikatan/2026-03-23/qkcik6pk/consolidate-2026.png?format=webp&w=360&q=90"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`container ${styles["story-grid"]}`}>
            <div className={styles["main-content"]} ref={iframeWidgetsRef}>
              <LazyCollection
                collection={data.collection}
                config={config}
                collectionTemplates={getAdsWrappedCollectionTemplate}
                lazyAfter={1}
                accentColor={"#2f81cd"}
                pageType={"cricket"}
              />
            </div>

            <div ref={StoryCollectionWidgetsRef}>
              <YoutubeVideoGallery title="IPL Reels" titleClassName="blue-theme" />
            </div>

            <div className={styles["terms-wrapper"]}>
              <div className="container">
                <div className={styles["social-wrapper"]}>
                  <div className={styles["social-media-wrap"]}>
                    <h3>Follow Sathya: </h3>
                    <div>
                      <a href="https://www.facebook.com/sathya.retail" rel="noopener noreferrer" target="_blank">
                        <img
                          src="https://media.vikatan.com/vikatan/2024-03/78184621-9290-492c-b851-1bcde30d0b82/ipl_fb.png"
                          alt="sathya Facebook"
                        />
                      </a>
                    </div>
                    <div>
                      <a href="https://www.instagram.com/sathya.retail/" rel="noopener noreferrer" target="_blank">
                        <img
                          src="https://media.vikatan.com/vikatan/2024-03/aa228433-397b-40b8-899f-37f2840aa875/ipl_instagram.png"
                          alt="sathya Instagram"
                        />
                      </a>
                    </div>
                    <div>
                      <a
                        href="https://adtarbo.eywamedia.com/qr/scan?c=6529256630383"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <img
                          src="https://media.vikatan.com/vikatan/2024-03/621beace-7c5a-4ed0-a5f7-02a0d1634035/ipl_whatsapp.png"
                          alt="sathya Whatsapp"
                        />
                      </a>
                    </div>
                  </div>
                  <div className={styles["social-media-wrap"]}>
                    <h3>Follow Vikatan: </h3>
                    <div>
                      <a href="https://www.facebook.com/SportsVikatan/" rel="noopener noreferrer" target="_blank">
                        <img
                          src="https://media.vikatan.com/vikatan/2024-03/78184621-9290-492c-b851-1bcde30d0b82/ipl_fb.png"
                          alt="Vikatan Facebook"
                        />
                      </a>
                    </div>
                    <div>
                      <a href="https://www.instagram.com/sportsvikatan/" rel="noopener noreferrer" target="_blank">
                        <img
                          src="https://media.vikatan.com/vikatan/2024-03/aa228433-397b-40b8-899f-37f2840aa875/ipl_instagram.png"
                          alt="Vikatan Instagram"
                        />
                      </a>
                    </div>
                    <div>
                      <a href="https://twitter.com/sportsvikatan" rel="noopener noreferrer" target="_blank">
                        <img
                          src="https://media.vikatan.com/vikatan/2024-03/2da849cb-adcd-45c1-8769-3ecf3421f303/ipl_twitter.png"
                          alt="Vikatan Twitter"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className={styles["terms-points"]}>
                  <h2>
                    <a
                      href="https://www.vikatan.com/cricket-quiz-terms-and-conditions"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <span>*</span> Terms and Conditions
                    </a>
                  </h2>
                  <div className={styles["terms-list"]}>
                    <h3>Disclaimer:</h3>
                    <p>
                      1. By participating in the &quot;Sixer Adi,&quot; (&quot;Contest&quot;), you acknowledge and agree
                      to abide by the following Terms and Conditions*. Vikatan reserves the right to modify or update
                      these terms* at any time without prior notice.
                    </p>
                    <p>
                      2. The Contest is organized solely for entertainment and educational purposes. It is not
                      associated with, endorsed by, or affiliated with any specific sports organization, team, or
                      governing body.
                    </p>
                    <p>
                      3. Only one participant per family is allowed. Any violation of this rule may result in
                      disqualification of the contestant(s) from receiving the final prizes, at the discretion of the
                      authority.
                    </p>
                    <p>
                      4. By participating in this contest you agree to be bound by the Terms and conditions provided in
                      the Link. If you do not agree to with any part of the terms, please do not participate.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div />
      </div>
    </React.Fragment>
  );
};

IPL2026Page.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
